module.exports = __webpack_public_path__ + "static/media/VerdePng.ebfa7b22.png";